var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgBank = function SvgBank(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 40 40",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#95A5A5",
    d: "M5.862 13.696h28.44v20.69H5.862v-20.69z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#D1D4D1",
    d: "M31.724 14.903h4.828v18.046h-4.828V14.903zM8.276 32.628H3.448V15.534h4.828v17.094z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#BDC3C7",
    d: "M30.345 13.35h7.586v1.725c0 .762-.617 1.38-1.379 1.38h-4.827c-.762 0-1.38-.618-1.38-1.38v-1.724zM31.725 31.627h4.827c.762 0 1.38.617 1.38 1.38v1.723h-7.587v-1.724c0-.762.618-1.38 1.38-1.38zM8.276 16.454H3.448c-.761 0-1.379-.617-1.379-1.379v-1.724h7.586v1.724c0 .762-.617 1.38-1.379 1.38zM9.655 34.73H2.07v-1.724c0-.762.618-1.38 1.38-1.38h4.827c.762 0 1.38.618 1.38 1.38v1.724z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ABDAFF",
    d: "M1.38 10.04h37.93v2.966c0 .38-.309.69-.69.69H2.07c-.382 0-.69-.31-.69-.69V10.04zM2.07 34.386h36.55c.382 0 .69.308.69.69v3.447H1.38v-3.448c0-.38.308-.69.69-.69z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#579FD7",
    d: "M39.31 10.937H.69c-.381 0-.69-.309-.69-.69v-3.63c0-.3.195-.567.483-.658L19.387.093c.4-.124.827-.124 1.226 0L39.517 5.96c.288.09.483.357.483.659v3.63c0 .38-.309.69-.69.69z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#ABDAFF",
    d: "M2.758 8.178v-.036l17.035-5.288c.133-.04.275-.04.408 0l17.04 5.288v.036H2.758z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#7ED09E",
    d: "M27.586 24.04c0 4.19-3.396 7.587-7.586 7.587s-7.586-3.397-7.586-7.586c0-4.19 3.396-7.587 7.586-7.587s7.586 3.397 7.586 7.587z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#24AE5F",
    fillRule: "evenodd",
    d: "M18.276 27v-2.169h1.852L21.869 27h.7v-2.169h.931v-.48h-.93v-.702h.93v-.48h-.93V21h-.854v2.169h-1.853L18.131 21h-.7v2.169H16.5v.48h.93v.702h-.93v.48h.93V27h.846zm.52-3.831h-.52v-.652l.52.652zm-.52 1.183h1.468l-.564-.703h-.905v.703zm3.44 0h-.905l-.563-.703h1.468v.703zm-.52.48l.52.65v-.65h-.52z",
    clipRule: "evenodd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#579FD7",
    d: "M.69 37.144h38.62c.381 0 .69.309.69.69v1.38c0 .38-.309.689-.69.689H.69c-.381 0-.69-.309-.69-.69v-1.38c0-.38.309-.689.69-.689z"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBank, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bank.79d2db90.svg";
export { ForwardRef as ReactComponent };